
  import { mapGetters } from 'vuex';

  export default {
    data () {
      return {
        feeTypeKeys: ['document_issuing', 'early_repayment', 'vacate_fee', 'transfer_rates_fee', 'late_payment_fee',
                      'arrangement_fee', 'legal_fee', 'application_fee', 'other_fees']
      };
    },
    computed: {
      ...mapGetters('products', { comparison: 'getComparison', mortgage: 'get' }),
      fees () {
        return this.feeTypes.map((fee) => {
          return { text: this.mortgage[`${fee}_note`], title: fee };
        });
      },
      feeTypes () {
        return this.feeTypeKeys.filter(feeType => {
          return !((this.mortgage.rate_type !== 'FIX' && feeType === 'early_repayment') ||
            (this.mortgage.rate_type !== 'VAR' && feeType === 'transfer_rates_fee') ||
            (['arrangement_fee', 'legal_fee', 'application_fee'].includes(feeType) && !this.mortgage[feeType]));
        });
      }
    }
  };
